import * as Yup from "yup";
import {
    phoneRegex,
    zipRegex,
    dateCantBeInFuture,
    stateRegEx
} from "./validationFunctions";

export const authorizationToReleaseValidations = (section, languageText) => {
    if (section.active) {
        return Yup.object().shape({

            facilityList: Yup.array().min(1, languageText.ErrorChecking.ValidatorText.MinOnePhysician),

            discloseTo: Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.MinOneParty
                ),


            RFName: Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.FirstName

                ),
            RLName: Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.LastName
                ),

            RPhone: Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.PhoneNumber
                )
                .matches(
                    phoneRegex,
                    languageText.ErrorChecking.ValidatorText.PhoneNumberInvalid

                ),

            RFax: Yup.string()
                .matches(
                    phoneRegex,
                    languageText.ErrorChecking.ValidatorText.InvalidFax
                ),

            RAddress1: Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.MissingAddress
                ),

            RCity: Yup.string().required(
                () =>
                    languageText.ErrorChecking.ValidatorText.CityMissing

            ),

            RState: Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.StateMissing

                ).matches(stateRegEx, languageText.ErrorChecking.ValidatorText.StateInvalid)
            ,


            RZip: Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.ZipMissing
                ).matches(
                    zipRegex,
                    languageText.ErrorChecking.ValidatorText.ZipMissing
                )


        });
    } else { return Yup.object().shape(); }
};
